// Module
var code = "<h2 class=\"interiorSectionHeading\"> Eligibility </h2> <p>You may qualify if:</p> <ul> <li> You can&#39;t work for pay when the work involves significant physical or mental activities.</li> <li> You are a veteran who has been determined to be unemployable due to a service-connected condition.</li> </ul> ";
// Exports
export default code;